import React, { useState } from "react";

import { MIN_PASSWORD_LENGTH } from "@intelligems/ig-types/dtos/users";
import { useUser } from "@src/api/user-auths/login";
import { usePatchUser } from "@src/api/users/patch-user";
import { Logout } from "@src/utils";

import { ForcePasswordResetView } from "./ForcePasswordReset.view";

export const ForcePasswordReset = () => {
  const user = useUser();
  const patchUser = usePatchUser();
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const loggedIn = user.data && user.data.type === "login" ? user.data : null;

  const handleSubmit = () => {
    if (!loggedIn || password.length < MIN_PASSWORD_LENGTH) {
      return;
    }
    setErrorMessage(null);
    patchUser.mutate(
      {
        queryParams: undefined,
        pathParams: { id: loggedIn.user.id },
        body: {
          user: {
            id: loggedIn.user.id,
            organizationId: loggedIn.user.organizationId,
            password,
          },
        },
      },
      {
        onError: () =>
          setErrorMessage("Something went wrong. Please try again."),
      }
    );
  };

  return (
    <ForcePasswordResetView
      password={password}
      minLength={MIN_PASSWORD_LENGTH}
      isSubmitting={patchUser.isPending}
      errorMessage={errorMessage}
      onPasswordChange={(value) => {
        setPassword(value);
        if (errorMessage) {
          setErrorMessage(null);
        }
      }}
      onSubmit={handleSubmit}
      onLogout={Logout}
    />
  );
};
